module.exports = __webpack_public_path__ + "static/heroAdmitidos-42f51f5f3bf4677a649ed65d5e92f5bb.png";